/**
 * @generated SignedSource<<eb7e99298ec100f87034445aaebb6278>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type B2CcouponStatus = "AVAILABLE" | "CONSUMED" | "RESERVED" | "REVOKED" | "%future added value";
export type lockCouponsQuery$variables = {
  hubId: string;
  hubName: string;
};
export type lockCouponsQuery$data = {
  readonly b2CCouponBalance: {
    readonly available: number;
    readonly consumed: number;
    readonly reserved: number;
  };
  readonly b2CCouponOfferAvailability: ReadonlyArray<{
    readonly offer: {
      readonly coupons: number;
      readonly description: string | null | undefined;
      readonly freeMinutes: number;
      readonly id: string;
      readonly priceCents: number;
      readonly title: string;
    };
    readonly purchasable: boolean;
    readonly remainingForUser: number | null | undefined;
    readonly remainingInHub: number | null | undefined;
  }>;
  readonly b2CCoupons: {
    readonly nodes: ReadonlyArray<{
      readonly createdAt: any;
      readonly expiresAt: any | null | undefined;
      readonly freeMinutes: number;
      readonly hubId: string | null | undefined;
      readonly id: string;
      readonly note: string | null | undefined;
      readonly purchaseId: string | null | undefined;
      readonly status: B2CcouponStatus;
    }>;
    readonly totalCount: number;
  };
  readonly hubMeta: {
    readonly hub: {
      readonly id: string;
    };
    readonly id: string;
    readonly name: string;
  };
};
export type lockCouponsQuery = {
  response: lockCouponsQuery$data;
  variables: lockCouponsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubName"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "hubId",
    "variableName": "hubId"
  }
],
v7 = {
  "alias": null,
  "args": (v6/*:: as any*/),
  "concreteType": "B2CcouponBalance",
  "kind": "LinkedField",
  "name": "b2CCouponBalance",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "available",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reserved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "consumed",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "freeMinutes",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": (v6/*:: as any*/),
  "concreteType": "B2CcouponOfferAvailability",
  "kind": "LinkedField",
  "name": "b2CCouponOfferAvailability",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "purchasable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingForUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingInHub",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "B2CcouponOffer",
      "kind": "LinkedField",
      "name": "offer",
      "plural": false,
      "selections": [
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "coupons",
          "storageKey": null
        },
        (v8/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceCents",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "pagination",
      "value": {
        "page": 0,
        "pageSize": 50
      }
    }
  ],
  "concreteType": "B2CcouponPage",
  "kind": "LinkedField",
  "name": "b2CCoupons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "B2Ccoupon",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        (v8/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hubId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expiresAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "note",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "purchaseId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "b2CCoupons(pagination:{\"page\":0,\"pageSize\":50})"
},
v11 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Int"
},
v12 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "String"
},
v13 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v14 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v15 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "Int"
},
v16 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "UUID"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "lockCouponsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v2/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v3/*:: as any*/),
            (v4/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v5/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      (v7/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "lockCouponsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "storageKey": null
      },
      (v7/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "208a5dd155739fc83cd5091464768a6c",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "b2CCouponBalance": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "B2CcouponBalance"
        },
        "b2CCouponBalance.available": (v11/*:: as any*/),
        "b2CCouponBalance.consumed": (v11/*:: as any*/),
        "b2CCouponBalance.reserved": (v11/*:: as any*/),
        "b2CCouponOfferAvailability": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "B2CcouponOfferAvailability"
        },
        "b2CCouponOfferAvailability.offer": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "B2CcouponOffer"
        },
        "b2CCouponOfferAvailability.offer.coupons": (v11/*:: as any*/),
        "b2CCouponOfferAvailability.offer.description": (v12/*:: as any*/),
        "b2CCouponOfferAvailability.offer.freeMinutes": (v11/*:: as any*/),
        "b2CCouponOfferAvailability.offer.id": (v13/*:: as any*/),
        "b2CCouponOfferAvailability.offer.priceCents": (v11/*:: as any*/),
        "b2CCouponOfferAvailability.offer.title": (v14/*:: as any*/),
        "b2CCouponOfferAvailability.purchasable": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Boolean"
        },
        "b2CCouponOfferAvailability.remainingForUser": (v15/*:: as any*/),
        "b2CCouponOfferAvailability.remainingInHub": (v15/*:: as any*/),
        "b2CCoupons": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "B2CcouponPage"
        },
        "b2CCoupons.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "B2Ccoupon"
        },
        "b2CCoupons.nodes.createdAt": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "DateTime"
        },
        "b2CCoupons.nodes.expiresAt": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "DateTime"
        },
        "b2CCoupons.nodes.freeMinutes": (v11/*:: as any*/),
        "b2CCoupons.nodes.hubId": (v16/*:: as any*/),
        "b2CCoupons.nodes.id": (v13/*:: as any*/),
        "b2CCoupons.nodes.note": (v12/*:: as any*/),
        "b2CCoupons.nodes.purchaseId": (v16/*:: as any*/),
        "b2CCoupons.nodes.status": {
          "enumValues": [
            "AVAILABLE",
            "RESERVED",
            "CONSUMED",
            "REVOKED"
          ],
          "nullable": false,
          "plural": false,
          "type": "B2CcouponStatus"
        },
        "b2CCoupons.totalCount": (v11/*:: as any*/),
        "hubMeta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.id": (v13/*:: as any*/),
        "hubMeta.id": (v13/*:: as any*/),
        "hubMeta.name": (v14/*:: as any*/)
      }
    },
    "name": "lockCouponsQuery",
    "operationKind": "query",
    "text": "query lockCouponsQuery(\n  $hubName: String!\n  $hubId: UUID!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    hub {\n      id\n    }\n  }\n  b2CCouponBalance(hubId: $hubId) {\n    available\n    reserved\n    consumed\n  }\n  b2CCouponOfferAvailability(hubId: $hubId) {\n    purchasable\n    remainingForUser\n    remainingInHub\n    offer {\n      id\n      title\n      description\n      coupons\n      freeMinutes\n      priceCents\n    }\n  }\n  b2CCoupons(pagination: {page: 0, pageSize: 50}) {\n    totalCount\n    nodes {\n      id\n      status\n      freeMinutes\n      hubId\n      expiresAt\n      note\n      purchaseId\n      createdAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "95745a220c4438ddb97dd60b7d041f78";

export default node;
